module.exports = __webpack_public_path__ + "img/banner-game.ff3558ef.jpg";